import { render, staticRenderFns } from "./AddButtonInForm.vue?vue&type=template&id=1c8b91d8&scoped=true"
import script from "./AddButtonInForm.vue?vue&type=script&lang=js"
export * from "./AddButtonInForm.vue?vue&type=script&lang=js"
import style0 from "./AddButtonInForm.vue?vue&type=style&index=0&id=1c8b91d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8b91d8",
  null
  
)

export default component.exports